export default "__VITE_ASSET__BJQIvF2s__"